import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TableKey } from '@tradecafe/types/core';

export interface CompanyLogOverlayOptions {
  title: string;
  account: string;
}

@Component({
  selector: 'tc-company-log-overlay',
  templateUrl: './company-log-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CompanyLogOverlayComponent {
  private dialogData = inject<CompanyLogOverlayOptions>(MAT_DIALOG_DATA)
  private dialogRef = inject<MatDialogRef<CompanyLogOverlayComponent, void>>(MatDialogRef)


  tableIdentity = TableKey.CompaniesAccountAudit;
  title = this.dialogData.title;
  auditLogFilter = {
    component: ["account"],
    resource_account_id: [this.dialogData.account.toString()],
  };
  cancel() {
    this.dialogRef.close();
  }
}
